import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

const tr = {

    ...zhLocale
};
export default tr;
